/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Push_EnableInputs */

const vi_notif_push_enable = /** @type {(inputs: Notif_Push_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật thông báo đẩy`)
};

/**

* @param {Notif_Push_EnableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_push_enable = /** @type {((inputs?: Notif_Push_EnableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Push_EnableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_push_enable(inputs)
});